export const editCssMenu = {
  'virtual-photo-mosaic-element': {
    whiteButton: true
  },
  'tile-card-element': {
    whiteButton: true
  }
};
export const highlightElement = {
  'virtual-photo-mosaic-element': true
};